export default __webpack_public_path__ + "static/media/cart-light.fbd5b000.svg";